/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import {Action, ActionType}      from '@/models/action';

/**
 *
 * @class SimpleDebugAction
 *
 * @brief launch a simulation; but in debugging mode.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class SimpleDebugAction extends Action {

  /* the callback invoke the simulation button */
  private clicker: () => void;

  constructor(
    clicker: () => void
  ) {

    super({
      key:   'window.simplesim',
      type:  ActionType.Window_SimpleDebug,
      label: 'Launch Simple Simulation (Debug Mode)',
      icon:  '<i class="fas fa-tools"></i>',
      tip:   'Launch a Simple Simulation (Debug Mode)'
    });

    this.clicker = clicker;
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    this.clicker();

    return true;
  }
}
